export default __webpack_public_path__ + "static/media/Slider_Company.4ac0953e.mp4";